import { Injectable } from '@angular/core';
import { Store, State } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { Loadable } from '../common/loadable';
import { LoadPriceTypeListAction, LoadVariantCombinationListAction } from './actions';
import { AppState } from "src/state/app.state";
import { ProductionPriceListApiService } from '../../api/services/production-price-list-api.service';
import { PriceListForm, PriceType } from './state-models/price-list-form';
import { PriceListFormState } from './state';
import { Paging } from '../common/state-models/paging';


@Injectable({
  providedIn: "root",
})

export class PriceListFormStateService {
  constructor(
    private appStore: Store<AppState>,
    private apiService: ProductionPriceListApiService,
    private appState: State<AppState>) { }

  @Loadable()
  async fetchPriceTypeList(): Promise<void> {
    const list = await this.apiService.fetchPriceTypeList();
    const listWithPrice: PriceType[] = list.map(
      p => ({
        ...p,
        priceValue: undefined
      }))
    this.appStore.dispatch(new LoadPriceTypeListAction(listWithPrice));
  }

  @Loadable()
  async fetchVariantCombinations(filterExpression: string): Promise<void> {
    // Fixed paging for variant combinations in Price list service-
    const payload = {
      paging: {
        page: 1,
        offset: 20
      },
      order: null,
      filter: filterExpression
    };

    const suggestions = await this.apiService.fetchVariantCombinations(payload);
    this.appStore.dispatch(new LoadVariantCombinationListAction(suggestions));
  }

  @Loadable()
  async submitForm(input: PriceListForm): Promise<void> {
    await this.apiService.submitPriceListForm(input);
  }

  getPriceTypes() {
    return this.appStore.select(state => state.priceListForm.priceTypes);
  }

  getVariantSuggestions() {
    return this.appStore.select(state => state.priceListForm.variantCombination);
  }

}
